import type { JobListQuery, Page } from '@chukua/common';
import { Switch, Table, type TableColumnsType } from 'antd';
import { SearchX } from 'lucide-react';
import { EmptyState } from '../../../../../shared/components/EmptyState';
import { ListSearch } from '../../../../../shared/components/ListSearch';
import type { ListQueryControls } from '../../../../../shared/hooks/use-list-query';
import type { JobListItem } from '../../../jobs.api';
import { JobQuickFilters } from './JobQuickFilters';

interface JobsTableProps {
  page: Page<JobListItem>;
  columns: TableColumnsType<JobListItem>;
  list: ListQueryControls<JobListQuery>;
  isRefreshing: boolean;
}

/** Search box plus the server-paged table; the old rows stay up, dimmed, while the next page loads. */
export function JobsTable({ page, columns, list, isRefreshing }: JobsTableProps) {
  return (
    <div className="flex flex-col gap-4">
      <JobQuickFilters list={list} />
      <div className="flex flex-wrap items-center gap-3">
        <ListSearch value={list.query.q} placeholder="Search job number or customer" onSearch={(q) => list.setQuery({ q }, { replace: true })} />
        <label className="flex items-center gap-2 text-sm text-muted">
          <Switch checked={list.query.quoteExpired === true} onChange={(checked) => list.setQuery({ quoteExpired: checked ? true : undefined })} />
          Expired quotes only
        </label>
      </div>
      <Table
        rowKey="id"
        dataSource={page.items}
        columns={columns}
        loading={isRefreshing}
        scroll={{ x: 'max-content' }}
        locale={list.isFiltered ? { emptyText: <NoMatchingJobs /> } : undefined}
        {...list.tableProps<JobListItem>(page.total)}
      />
    </div>
  );
}

function NoMatchingJobs() {
  return <EmptyState icon={SearchX} title="No matching jobs" description="No jobs match this search or these filters." />;
}
